import React from "react";
import { Star, Quote } from "lucide-react";
import { TESTIMONIALS } from "../mock";

const Testimonials = () => {
  return (
    <section className="py-20 md:py-28 px-5 md:px-8">
      <div className="max-w-7xl mx-auto">
        <div className="text-center max-w-2xl mx-auto fade-up">
          <div className="flex items-center justify-center gap-2 mb-4">
            <span className="h-px w-6 bg-[#159A90]" />
            <span className="text-[12px] font-bold tracking-[0.16em] text-[#159A90] uppercase">
              Loved by Families
            </span>
            <span className="h-px w-6 bg-[#159A90]" />
          </div>
          <h2 className="font-heading font-extrabold text-[#1B2A4A] text-[32px] md:text-[42px] leading-tight">
            Loved by the families we've cared for so far
          </h2>
          <div className="flex items-center justify-center gap-3 mt-5">
            <div className="flex">
              {[...Array(5)].map((_, i) => (
                <Star key={i} size={18} className="text-[#F5B301] fill-[#F5B301]" />
              ))}
            </div>
            <span className="font-heading font-bold text-[#1B2A4A]">4.8 out of 5</span>
            <span className="text-[14px] text-[#8b96a3]">from 80+ verified reviews</span>
          </div>
        </div>

        <div className="grid md:grid-cols-2 gap-6 mt-14">
          {TESTIMONIALS.map((t, i) => (
            <div
              key={t.name}
              className="relative bg-white rounded-[24px] p-7 border border-[#DEE6EE] shadow-[0_8px_24px_rgba(0,0,0,0.04)] hover:shadow-[0_18px_45px_rgba(0,0,0,0.1)] transition-shadow fade-up"
              style={{ transitionDelay: `${(i % 2) * 80}ms` }}
            >
              <Quote size={34} className="text-[#8FD1CB] fill-[#8FD1CB] mb-3" />
              <p className="text-[15.5px] text-[#3a4757] leading-relaxed">
                “{t.text}”
              </p>
              <div className="flex items-center gap-3 mt-6 pt-5 border-t border-[#ECE3D3]">
                <span className="flex items-center justify-center w-11 h-11 rounded-full bg-[#1B2A4A] text-white font-heading font-bold">
                  {t.initial}
                </span>
                <div>
                  <p className="font-heading font-bold text-[15px] text-[#1B2A4A]">
                    {t.name}
                  </p>
                  <p className="text-[13px] text-[#8b96a3]">{t.city}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
